import { Routes } from '@angular/router';

import { SERVICE_ANALYTICS } from '../shared/models/list';
import { DatacenterComponent } from '../shared/datacenter/datacenter.component';
import { DatacenterViewCustomizationComponent } from
	'../shared/datacenter/view-customization/datacenter-view-customization.component';

import { fastLaneUserGuard } from './guards/fastlane-user.guard';
import { FastLaneComponent } from './components/fastlane.component';
import { WizardComponent } from './components/wizard/wizard.component';
import { StepDetailsComponent } from './components/wizard/step-details/step-details.component';
import { StepHeaderComponent } from './components/wizard/step-header/step-header.component';
import { StepTransportComponent } from './components/wizard/step-transport/step-transport.component';
import { StepSummaryComponent } from './components/wizard/step-summary/step-summary.component';
import { PAGE_NAME_STEPS } from './services/fastlane-wizard.service';
import { fastlaneWizardExitGuard } from './guards/fastlane-wizard-exit.guard';
import { wizardEnterGuard } from './guards/wizard-enter.guard';
import { PrototypeCardComponent } from './components/cards/prototype-card.component';

export const routes: Routes = [

	{
		path: 'fastLaneWizard',
		component: FastLaneComponent,
		canActivate: [fastLaneUserGuard],
		data: { pageName: 'FastLane - Dashboard', service: SERVICE_ANALYTICS.FASTLANE },
	},
	{
		path: 'wizard',
		component: WizardComponent,
		canDeactivate: [fastlaneWizardExitGuard],
		children: [
			{
				path: '',
				redirectTo: PAGE_NAME_STEPS[0],
				pathMatch: 'full',
				data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.FASTLANE }
			},
			{
				path: PAGE_NAME_STEPS[0],
				component: StepHeaderComponent,
				canActivate: [fastLaneUserGuard, wizardEnterGuard],
				data: { pageName: 'FastLane - Wizard Step 1 (Header)', service: SERVICE_ANALYTICS.FASTLANE },
			},
			{
				path: PAGE_NAME_STEPS[1],
				component: StepDetailsComponent,
				canActivate: [fastLaneUserGuard, wizardEnterGuard],
				data: { pageName: 'FastLane - Wizard Step 2 (Details)', service: SERVICE_ANALYTICS.FASTLANE },
			},
			{
				path: PAGE_NAME_STEPS[2],
				component: StepTransportComponent,
				canActivate: [fastLaneUserGuard, wizardEnterGuard],
				data: { pageName: 'FastLane - Wizard Step 3 (Transport)', service: SERVICE_ANALYTICS.FASTLANE },
			},
			{
				path: PAGE_NAME_STEPS[3],
				component: StepSummaryComponent,
				canActivate: [fastLaneUserGuard, wizardEnterGuard],
				data: { pageName: 'FastLane - Wizard Step 4 (Summary)', service: SERVICE_ANALYTICS.FASTLANE },
			},
		],
	},
	{
		path: 'prototype',
		children: [
			{
				path: '',
				redirectTo: 'datacenter',
				pathMatch: 'full',
				data: { pageName: 'Redirect' }
			},
			{
				path: 'datacenter',
				children: [
					{
						path: '',
						component: DatacenterComponent,
						data: {
							pageName: 'Prototypes - Datacenter',
							service: SERVICE_ANALYTICS.FASTLANE,
							type: 'prototypes',
							title: 'datacenter.prototypes',
							exportExcelName: 'Prototypes'
						}
					},
					{
						path: 'view',
						component: DatacenterViewCustomizationComponent,
						data: { pageName: 'Prototypes - Datacenter Customization', service: SERVICE_ANALYTICS.FASTLANE }
					},
				],
			},
			{
				path: 'card/:supplierReference',
				component: PrototypeCardComponent,
				data: { pageName: 'Prototypes - Card', service: SERVICE_ANALYTICS.FASTLANE }
			}
		]
	},
];
